package com.peerke.outdoorpuzzlegame.client.common

fun main(vararg args: String) {
    logDebug("CommonClientLibrary loaded.")
}
